import { useEffect, useState, useEffectEvent } from 'react';

import canopy from './flyingCanopy.png';
import windT from './WindT.png';
import sydKarta from './sydkartaSquare-small.jpg';

import Button from 'react-bootstrap/Button';


import windCone0 from './windCone/windCone0.png'
import windCone20 from './windCone/windCone20.png'
import windCone40 from './windCone/windCone40.png'
import windCone60 from './windCone/windCone60.png'
import windCone80 from './windCone/windCone80.png'
import windCone100 from './windCone/windCone100.png'

function useInterval(callback, delay) {
    const onTick = useEffectEvent(callback);

    useEffect(() => {
        if (delay === null) {
            return;
        }
        const id = setInterval(() => {
            onTick();
        }, delay);
        return () => clearInterval(id);
    }, [delay]);
}

const randomWind = () => ({
    direction: Math.random() * 2 * Math.PI,
    speed: Math.random() * 10
});

const CanopyPage = ({ }) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setScreenHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [canvas, setCanvas] = useState();

    const stepTime = 16.6; //ms
    const timeFactor = stepTime / 1000;
    const airSpeed = 10;
    const sinkRate = 5;
    const startingHeight = 600;

    const imageWidth = 3500; // meters also height


    const [running, setRunning] = useState(false);

    let [pos, setPos] = useState(
        { x: 300, y: 400, height: startingHeight, direction: Math.PI }
    );
    let [wind, setWind] = useState(randomWind());

    let [arrows, setArrows] = useState({
        ArrowLeft: false,
        ArrowRight: false,
        ArrowUp: false,
        ArrowDown: false,
        Space: false,
    });
    var pixelScale = screenWidth / imageWidth;
    if (screenHeight > screenWidth) {
        pixelScale = screenHeight / imageWidth;
    }

    useInterval(() => {
        var sinkrateMultiplier = 1;
        var speedMultiplier = 1;
        var newDirection = pos.direction;
        if (arrows.ArrowRight && arrows.ArrowLeft) {
            sinkrateMultiplier = 0.6;
            speedMultiplier = 0.75;
        } else {
            if (arrows.ArrowRight) {
                speedMultiplier = 1.2;
                sinkrateMultiplier = 1.6;
                newDirection = pos.direction + (Math.PI / 3) * timeFactor;
            }
            if (arrows.ArrowLeft) {
                speedMultiplier = 1.2;
                sinkrateMultiplier = 1.6;
                newDirection = pos.direction - (Math.PI / 3) * timeFactor;
            }
        }

        var oldPos = pos;
        var newHeight = oldPos.height - (sinkRate * timeFactor * sinkrateMultiplier);
        if (newHeight < 0) {
            newHeight = 0;
        }

        var newPos = {
            x: oldPos.x + (airSpeed * pixelScale * timeFactor * speedMultiplier) * Math.sin(newDirection) -
                (wind.speed * pixelScale * timeFactor) * Math.sin(wind.direction),
            y: oldPos.y + (airSpeed * pixelScale * timeFactor * speedMultiplier) * Math.cos(newDirection + Math.PI) +
                (wind.speed * pixelScale * timeFactor) * Math.cos(wind.direction),
            height: newHeight,
            direction: newDirection,
        };

        if (canvas == null) return;
        const ctx = canvas.getContext("2d");
        ctx.lineWidth = 3;
        ctx.lineJoin = "round";
        if (pos.height < 100) {
            ctx.strokeStyle = "#ff0000";
        } else if (pos.height < 200) {
            ctx.strokeStyle = "#002aff";
        } else if (pos.height < 300) {
            ctx.strokeStyle = "#00ff00";
        } else if (pos.height < 500) {
            ctx.strokeStyle = "#FBEC5D";
        } else {
            ctx.strokeStyle = "#E0E0E0"
        }

        ctx.beginPath();
        ctx.moveTo(pos.x + 10, pos.y + 10);
        ctx.lineTo(newPos.x + 10, newPos.y + 10);
        ctx.stroke();

        setPos(newPos);
    }, running && pos.height > 0 ? stepTime : null);

    useEffect(() => {
        const handleKey = (e) => {
            const key = e.key;
            if (" " === key && e.type === "keydown") {
                console.log("running for space is: ", running);
                setRunning(state => !state);
            }
            setArrows((state) => {
                if ("ArrowLeft" === key) {
                    arrows.ArrowLeft = e.type === "keydown";
                }
                if ("ArrowRight" === key) {
                    arrows.ArrowRight = e.type === "keydown";
                }
                if ("ArrowUp" === key) {
                    arrows.ArrowUp = e.type === "keydown";
                }
                if ("ArrowDown" === key) {
                    arrows.ArrowDown = e.type === "keydown";
                }
                return arrows;
            });
        };
        document.addEventListener('keydown', handleKey, true);
        document.addEventListener('keyup', handleKey, true);

        return () => {
            document.removeEventListener('keydown', handleKey);
            document.removeEventListener('keyup', handleKey);
        };
    }, [setArrows]);

    var windCone = windCone0;
    if (wind.speed >= 7.8) {
        windCone = windCone100;
    } else if (wind.speed >= 6) {
        windCone = windCone80;
    } else if (wind.speed >= 4.5) {
        windCone = windCone60;
    } else if (wind.speed >= 4.5) {
        windCone = windCone40;
    } else if (wind.speed >= 3) {
        windCone = windCone20;
    }

    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            position: 'relative',
            overflow: 'hidden',
        }}
            onClick={e => {
                if (running) {
                    return;
                }
                setPos({
                    x: e.pageX - 10,
                    y: e.pageY - 10,
                    height: startingHeight,
                    direction: Math.random() * 2 * Math.PI
                });
                setRunning(true);
            }}>
            <div
                style={{
                    position: 'absolute',
                    backgroundColor: 'white',
                    width: '90px',
                    textAlign: 'right',
                    paddingRight: '5px',
                }}
            >
                <p style={{ marginBottom: '0px', fontSize: '1.4rem' }}>
                    {Math.abs(pos.height.toFixed(0))} <span style={{ float: 'right' }}>&nbsp;m</span>
                </p>
                <p style={{ marginBottom: '0px', display: 'none' }}>
                    {Math.abs(wind.speed.toFixed(1))} <span style={{ float: 'right' }}>&nbsp;m/s</span>
                </p>
            </div>
            {!running ?
                (<div
                    style={{
                        display: 'flex',
                        position: 'fixed',
                        backgroundColor: 'transparent',
                        justifyContent: 'justify-content',
                        maxWidth: 'fit-content',
                        textAlign: 'center',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        fontSize: '2rem'
                    }}

                >
                    <p
                        style={{
                            marginBottom: 0,
                            backgroundColor: 'white',
                        }}
                    >
                        Klicka på din uthoppspunkt!
                    </p>

                </div>) : null
            }
            {pos && pos.height === 0 ?
                (<div
                    style={{
                        position: 'fixed',
                        inset: '0px',
                        width: '30rem',
                        height: '5rem',
                        maxWidth: '100vw',
                        maxHeight: '100dvh',
                        margin: 'auto',
                        zIndex: 10,

                    }}
                >
                    <div
                        style={{
                            margin: '2rem',
                            padding: '2rem',
                            backgroundColor: 'white',
                            borderRadius: '2rem',
                            textAlign: 'center'

                        }}
                    >
                        <h3>Tillbaka på marken!</h3>
                        <p>Du hade {Math.abs(wind.speed.toFixed(1))} m/s wind från {((wind.direction / (2 * Math.PI)) * 360).toFixed(0)} grader</p>
                        <Button className='btn-light btn waves-effect waves-light btn-lg '
                            style={{ width: '50%' }} onClick={e => {
                                setRunning(false);
                                setPos({
                                    x: 500,
                                    y: 500,
                                    height: startingHeight,
                                    direction: Math.random() * 2 * Math.PI
                                });
                                setWind(randomWind());
                                const ctx = canvas.getContext("2d");
                                ctx.clearRect(0, 0, canvas.width, canvas.height);
                            }}>Kör igen!</Button>

                    </div>
                </div>) : null
            }


            <img
                key="field"
                style={{
                    zIndex: 1,
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%',
                }}
                src={sydKarta} alt="a balloon" />

            <img
                key="canopy"
                style={{
                    position: 'absolute',
                    zIndex: 3,
                    top: pos.y,
                    left: pos.x,
                    width: 20,
                    transform: 'rotate(' + ((pos.direction / (2 * Math.PI)) * 360) + 'deg)',
                    display: running ? 'block' : 'none',

                }}
                src={canopy} alt="a canopy" />

            <img
                key="windCone"
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    top: (screenHeight / 2) - 160 * pixelScale,
                    left: (screenWidth / 2) - 210 * pixelScale,
                    width: 20,
                    //transform: 'rotate(' + ((wind.direction / (2 * Math.PI)) * 360) + 'deg)'

                }}
                src={windCone} alt="Wind cone showing wind strength" />

            <img
                key="windT"
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    top: screenHeight / 2 + 60 * pixelScale,
                    left: screenWidth / 2 - 20 * pixelScale,
                    width: 20,
                    transform: 'rotate(' + ((wind.direction / (2 * Math.PI)) * 360) + 'deg)'

                }}
                src={windT} alt="Wind t showing wind direction" />


            <canvas width={screenWidth} height={screenHeight} ref={setCanvas} style={{
                zIndex: 2,
                float: 'left',
                margin: 0,
                padding: 0,
                display: 'block',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                position: 'absolute'
            }} />


        </div >);
};

export default CanopyPage;